import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TEmployerId } from '@entities/modal/model/types/employerId';
import { updateEmployeeAccesses } from '@entities/myTeam/api/updateEmployeeAccesses';

export const useUpdateEmployeeAccesses = (id: TEmployerId) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['updateEmployeeAccesses'],
        mutationFn: updateEmployeeAccesses,
        onSuccess: (data) => {
            queryClient.setQueryData(['employeeAccesses', id], data);
        },
    });
};
